import { imgixHost } from 'src/config'
import Model, { encoders, ID, Integer } from 'src/models/model'
import SignageMediaClass from 'src/models/signage/SignageMediaClass'

export const MEDIA_FORMAT = {
  VIDEO: 'video',
  IMAGE: 'image'
}
MEDIA_FORMAT.ALL = _.values(MEDIA_FORMAT)

export default class SignageMediaItem extends Model {
  static name = 'SignageMediaItem'

  static deletable = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.SiteContent]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        default: null
      },
      description: {
        type: String,
        default: null
      },
      footerText: {
        type: String,
        default: null
      },
      media: {
        type: String,
        default: null
      },
      displayDuration: {
        type: Integer,
        default: 5
      },
      displayOrder: {
        type: Integer,
        default: 100
      },
      enabled: {
        type: Boolean,
        default: false
      },
      signageMediaClass: {
        type: SignageMediaClass,
        encode: encoders.hasOne,
        reference: true
      },
      mediaFormat: {
        type: String,
        default: null
      },
      hasLink: {
        type: Boolean,
        default: false
      },
      buttonText: {
        type: String,
        default: null
      },
      movieId: {
        type: ID,
        required: false
      }
    }

    this.computed = {
      mediaUrl () {
        if (!this.media) return ''

        return `${imgixHost}/${this.media}?auto=format`
      }
    }

    this.paginate = true
  }
}
